import Navbar from '../Navbar'
import Footer from '../Footer'
import PrintProcess from '../PrintProcess'
import RfqSection from '../RfqSection'
import ServiceHero from './ServiceHero'
import ServiceOverview from './ServiceOverview'
import ServiceApplications from './ServiceApplications'
import RelatedServices from './RelatedServices'
import useServiceSeo from './useServiceSeo'
import useHashScrollOnLoad from '../../hooks/useHashScrollOnLoad'
import {
  RESET_TITLES,
  SERVICES,
  SERVICE_ANALYTICS_IDS,
  SERVICE_CHROME,
  SERVICE_OG_IMAGES,
  SERVICE_PORTFOLIO_IMAGES,
  SERVICE_ROUTES,
} from '../../data/services'
import { SITE_URL } from '../../lib/routes'
import './service.css'

const OG_LOCALES = Object.freeze({ tr: 'tr_TR', en: 'en_US', de: 'de_DE' })

/**
 * One service page (pad printing, screen printing, assembly & trim) in one
 * locale. Copy and SEO live in src/data/services/*; the nine route files are
 * thin wrappers around this component. Six sections, each its own shape:
 * the operator's hero, the overview spread, the station film, the
 * applications beside their examples, the closing pair of links, contact.
 *
 * @param {{ service: 'pad' | 'screen' | 'assembly', lang: 'tr' | 'en' | 'de' }} props
 */
export default function ServicePage({ service, lang }) {
  const copy = SERVICES[service][lang]
  const chrome = SERVICE_CHROME[lang]

  useServiceSeo(copy.seo, RESET_TITLES[lang], {
    url: `${SITE_URL}${SERVICE_ROUTES[service][lang]}`,
    image: `${SITE_URL}${SERVICE_OG_IMAGES[service]}`,
    locale: OG_LOCALES[lang],
  })
  useHashScrollOnLoad()

  return (
    <>
      <Navbar lang={lang} />

      {/* <html lang> follows the route (DocumentLang in Router.jsx); main repeats
          it so the prerendered snapshot is right even before that effect runs. */}
      <main className="sp-page" data-service={service} lang={lang}>
        <ServiceHero service={service} hero={copy.hero} chrome={chrome} />
        <ServiceOverview intro={copy.intro} advantagesTitle={chrome.advantagesTitle} advantages={copy.advantages} />
        <PrintProcess lang={lang} variant={service} />
        <ServiceApplications
          lang={lang}
          title={chrome.applicationsTitle}
          items={copy.applications}
          stats={copy.stats}
          examplesTitle={chrome.portfolioTitle}
          images={SERVICE_PORTFOLIO_IMAGES}
        />
        <RelatedServices lang={lang} title={chrome.relatedTitle} items={copy.related} />
        <RfqSection
          lang={lang}
          title={chrome.contactTitle}
          description={copy.contact.description}
          subjectPrefix={copy.contact.subjectPrefix}
          service={SERVICE_ANALYTICS_IDS[service]}
          formLocation="service_contact"
        />
      </main>

      <Footer lang={lang} />
    </>
  )
}
